import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08023dd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-info" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("方案：")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("操作类型：")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("人数：")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("生效日期：")
const _hoisted_6 = { class: "block container-box" }
const _hoisted_7 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHead = _resolveComponent("PageHead")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageHead, null, {
      left: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", null, [
            _hoisted_2,
            _createElementVNode("b", null, _toDisplayString(_ctx.data.policy?.plan?.name), 1)
          ]),
          _createElementVNode("span", null, [
            _hoisted_3,
            _createElementVNode("b", {
              style: _normalizeStyle({
    color: _ctx.data.type==='减保' ? '#EA8571':'#65C4CE'
    })
            }, _toDisplayString(_ctx.data.type), 5)
          ]),
          _createElementVNode("span", null, [
            _hoisted_4,
            _createElementVNode("b", null, _toDisplayString(_ctx.data.person?.length), 1)
          ]),
          _createElementVNode("span", null, [
            _hoisted_5,
            _createElementVNode("b", null, _toDisplayString(_ctx.data.start_date), 1)
          ])
        ])
      ]),
      right: _withCtx(() => []),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_table, {
          data: _ctx.data.person,
          style: {"width":"100%"},
          "header-cell-class-name": "table-head",
          "row-style": { color: '#5E617D' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              fixed: "",
              label: "序号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "employee.name",
              fixed: "",
              label: "姓名"
            }),
            _createVNode(_component_el_table_column, {
              prop: "employee.idcard",
              label: "身份证号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "company_name",
              label: "被派遣单位"
            }),
            _createVNode(_component_el_table_column, {
              formatter: (item) => item.occupation_name? (item.occupation_name + `（${item.occupation_level}类）`): '',
              label: "所属工种"
            }, null, 8, ["formatter"])
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ])
  ], 64))
}